import apiService from './api';

export interface ScanInitiationResponse {
  scan_id: string;
  status: string;
  message: string;
}

export interface DiscoveredAsset {
  id: number;
  project_id: string;
  module: string;
  platform_id?: string;
  platform_name?: string;
  platform_domain?: string;
  asset_url: string;
  normalized_asset_url: string;
  asset_title?: string;
  asset_snippet?: string;
  asset_type?: string;
  status: string;
  first_seen_at?: string;
  last_seen_at?: string;
  last_scanned_at?: string;
  metadata_json?: Record<string, any>;
}

export interface ScanJobStatusResponse {
  scan_id: string;
  status: string;
  assets: DiscoveredAsset[] | null;
  error_detail?: string | null;
  started_at: string;
  completed_at?: string | null;
}

/**
 * Initiates a digital asset discovery scan for the social bookmarking module.
 */
export async function initiateSocialBookmarkScan(projectId: string): Promise<ScanInitiationResponse> {
  const payload = {
    project_id: projectId,
    module: "social_bookmarking",
  };
  
  return apiService.request<ScanInitiationResponse>(
    '/seo/implementation/scan',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    }
  );
}

/**
 * Polls the status of the social bookmarking scan.
 */
export async function getSocialBookmarkScanStatus(scanId: string): Promise<ScanJobStatusResponse> {
  return apiService.request<ScanJobStatusResponse>(
    `/seo/implementation/scan/${encodeURIComponent(scanId)}`,
    {
      method: 'GET',
    }
  );
}

/**
 * Initiates a digital asset discovery scan for the PDF submission module.
 */
export async function initiatePdfSubmissionScan(projectId: string): Promise<ScanInitiationResponse> {
  const payload = {
    project_id: projectId,
    module: "pdf_submission",
  };
  
  return apiService.request<ScanInitiationResponse>(
    '/seo/implementation/scan',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    }
  );
}

/**
 * Polls the status of the PDF submission scan.
 */
export async function getPdfSubmissionScanStatus(scanId: string): Promise<ScanJobStatusResponse> {
  return apiService.request<ScanJobStatusResponse>(
    `/seo/implementation/scan/${encodeURIComponent(scanId)}`,
    {
      method: 'GET',
    }
  );
}

/**
 * Initiates a digital asset discovery scan for the Web 2.0 / article submission module.
 */
export async function initiateWeb20Scan(projectId: string): Promise<ScanInitiationResponse> {
  const payload = {
    project_id: projectId,
    module: "web_2_0",
  };
  
  return apiService.request<ScanInitiationResponse>(
    '/seo/implementation/scan',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    }
  );
}

/**
 * Polls the status of the Web 2.0 / article submission scan.
 */
export async function getWeb20ScanStatus(scanId: string): Promise<ScanJobStatusResponse> {
  return apiService.request<ScanJobStatusResponse>(
    `/seo/implementation/scan/${encodeURIComponent(scanId)}`,
    {
      method: 'GET',
    }
  );
}

/**
 * Initiates a digital asset discovery scan for the image submission module.
 */
export async function initiateImageSubmissionScan(projectId: string): Promise<ScanInitiationResponse> {
  const payload = {
    project_id: projectId,
    module: "image_submission",
  };
  
  return apiService.request<ScanInitiationResponse>(
    '/seo/implementation/scan',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    }
  );
}

/**
 * Polls the status of the image submission scan.
 */
export async function getImageSubmissionScanStatus(scanId: string): Promise<ScanJobStatusResponse> {
  return apiService.request<ScanJobStatusResponse>(
    `/seo/implementation/scan/${encodeURIComponent(scanId)}`,
    {
      method: 'GET',
    }
  );
}

/**
 * Initiates a digital asset discovery scan for the classified ads module.
 */
export async function initiateClassifiedAdsScan(projectId: string): Promise<ScanInitiationResponse> {
  const payload = {
    project_id: projectId,
    module: "classified_ads",
  };
  
  return apiService.request<ScanInitiationResponse>(
    '/seo/implementation/scan',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    }
  );
}

/**
 * Polls the status of the classified ads scan.
 */
export async function getClassifiedAdsScanStatus(scanId: string): Promise<ScanJobStatusResponse> {
  return apiService.request<ScanJobStatusResponse>(
    `/seo/implementation/scan/${encodeURIComponent(scanId)}`,
    {
      method: 'GET',
    }
  );
}



